import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import '../styles/home.css';
import '../styles/fonts.css';
import 'aos/dist/aos.css';
import AOS from 'aos';

const Home = () => {
	const scrollToTop = () => {
		window.scrollTo(0, 0);
	};

	let Team = 'https://static.igem.wiki/teams/5066/global/teamlogo-1.png';
	let Bites = 'https://static.igem.wiki/teams/5066/home/mosquito-bites.png';
	// let Fly = 'https://static.igem.wiki/teams/5066/home/mosquito-flying.gif';
	let reverse =
		'https://static.igem.wiki/teams/5066/home/mosquito-flying-v2.gif';
	let ExploreButton =
		'https://static.igem.wiki/teams/5066/home/exploreprojectbutton.png';
	let WetlabButton =
		'https://static.igem.wiki/teams/5066/home/wetlabbutton.png';
	let HardwareButton =
		'https://static.igem.wiki/teams/5066/home/hardwarebutton.png';
	let HPButton =
		'https://static.igem.wiki/teams/5066/home/humanpracticebutton.png';
	let ModelButton =
		'https://static.igem.wiki/teams/5066/home/modelbutton.png';
	let HomePaper = 'https://static.igem.wiki/teams/5066/home/homepaper.png';
	let sosPic = 'https://static.igem.wiki/teams/5066/home/sospic.png';
	useEffect(() => {
		AOS.init();
	}, []);
	return (
		<div className='overflow-x-hidden'>
			{/* section title */}
			<div className='bg-gradient-to-b from-amber-50 to-[#FFE5D0] pb-5'>
				<div>
					<a href='https://2024.igem.wiki/gems-taiwan/awards'>
						<img
							className='w-[450px] h-auto absolute right-0 top-[-60px]'
							alt='Home prizes'
							src='https://static.igem.wiki/teams/5066/home/hp-icon.webp'
						/>
					</a>
				</div>
				<div className='block md:hidden grid-cols-4 pt-[100px]'>
					<div className='col-span-3 grid justify-items-end'>
						<img className='w-[25%]' src={Bites} alt='Bites' />
					</div>
					<div className='flex items-end justify-items-center'>
						<img
							className='w-[40%] scale-x-[-1]'
							src={reverse}
							alt='Reverse Mosquito'
						/>
					</div>
				</div>
				<div className='flex flex-row md:pt-[100px]'>
					<div className='w-full lg:w-[75%] -mt-[75px] md:mt-0'>
						<div className='grid grid-cols-10'>
							<div className='col-span-10 md:col-span-8 py-[20px] px-[20px]'>
								<img
									className='w-full h-auto'
									src={Team}
									alt='Team'
								/>
							</div>
							<div className='hidden md:block col-span-2 md:items-center'>
								<img
									className='w-[70%] -rotate-45'
									src={reverse}
									alt='Reverse Mosquito'
								/>
							</div>
							<div className='hidden md:block col-span-2 md:justify-items-center'>
								<img
									className='w-[80%]'
									src={reverse}
									alt='Reverse Mosquito'
								/>
							</div>
							<div className='col-span-10 md:col-span-8'>
								<p className='whitespace-pre-wrap text-sm md:text-lg lg:text-2xl px-4 md:px-1 md:pt-4 italic'>
									Recombinant biolarvicidal toxins, beetroot
									peel attractant, and Taiwan's first sticky
									ovitrap. With synthetic biology,{' '}
									<strong className='text-[#C94C67]'>
										Dengue Mos-quit-o
									</strong>{' '}
									by 2030!
								</p>
							</div>
						</div>
					</div>
					<div className='hidden md:block lg:w-[25%]'>
						<div>
							<img
								className='md:-ms-16'
								src={Bites}
								alt='Bites'
							/>
						</div>
						<div className='md:flex-col md:items-center'>
							<img
								className='w-[80%] scale-x-[-1]'
								src={reverse}
								alt='Reverse Mosquito'
							/>
						</div>
					</div>
				</div>
			</div>

			{/* section animation */}
			<div className='bg-gradient-to-b from-[#FFE5D0] via-[#FFECD5] to-[#F4FAF5] pb-8 px-4'>
				<div data-aos='zoom-in'>
					<div className='relative flex justify-center lg:p-8'>
						<img
							className='w-full max-w-8xl'
							src={sosPic}
							alt='Dengue Information'
						/>
						<div className='absolute inset-0 flex flex-col justify-center items-center text-center'>
							<p className='text-sm md:text-lg lg:text-2xl pt-1 lg:pt-6 px-16 font-semibold'>
								The <span className='font-bold'>WHO</span>{' '}
								reports that nearly half of the world's
								population is at risk of dengue,
							</p>
							<p className='text-sm md:text-lg lg:text-x2l'>
								with estimated up to{' '}
								<span className='text-[#C94C67] text-lg md:text-2xl lg:text-4xl font-bold'>
									4 Billion
								</span>{' '}
								at risk annually.
							</p>
							<p className='lg:mt-4 text-sm md:text-lg lg:text-2xl font-medium'>
								Immediate action is needed!
							</p>
							<p className='lg:mt-1 text-sm md:text-lg lg:text-2xl font-medium text-[#C94C67]'>
								Beating the dengue crisis is essential.
							</p>
						</div>
					</div>
				</div>
				<div>
					<div data-aos='fade-right'>
						<div className='text-center m-4 md:m-16'>
							<h2
								style={{
									fontFamily: 'MyCustomFont, sans-serif',
								}}
								className='text-3xl md:text-5xl xl:text-7xl text-[#C94C67] font-bold'
							>
								Current Solutions
							</h2>
							<p className='text-sm md:text-lg xl:text-2xl px-8 py-4'>
								The current solutions rely heavily on various
								vector control methods. However, the frequent
								use of chemical insecticides has led to the
								development of insecticide-resistant mosquitoes,
								hampering vector control strategies and
								aggravating the situation of dengue worldwide.
							</p>
						</div>
					</div>
				</div>
				<div data-aos='fade-right'>
					<div className='text-center m-4 md:m-16'>
						<h2
							style={{ fontFamily: 'MyCustomFont, sans-serif' }}
							className='text-3xl md:text-5xl xl:text-7xl text-[#C94C67] font-bold'
						>
							Our Synbio Solution
						</h2>
						<p className='text-sm md:text-lg xl:text-2xl px-8 py-4'>
							With a novel synergistic solution with recombinant
							biolarvicidal toxins, beetroot peel attractant, and
							sticky ovitrap, we can break mosquitoes' life cycle
							and reduce dengue transmission.
						</p>
					</div>
				</div>
			</div>

			{/* cave section */}
			<div className='bg-gradient-to-b from-[#F4FAF5] to-amber-50'>
				<div className='hidden md:block'>
					<img
						src='https://static.igem.wiki/teams/5066/home/tunnelfinal-1.png'
						alt='tunnel'
						className='w-full h-auto'
					></img>
				</div>
				<div className='md:hidden'>
					<img
						src='https://static.igem.wiki/teams/5066/home/rwdtunnelfinal-1.png'
						alt='tunnel'
						className='w-full h-auto'
					></img>
				</div>
				<div className='md:hidden'>
					<img
						src='https://static.igem.wiki/teams/5066/new/newtunnel-rwd.png'
						alt='tunnel'
						className='w-full h-auto'
					></img>
				</div>
			</div>

			{/* road seciton */}
			<div className='bg-amber-50'>
				<div data-aos='fade-in'>
					<img
						className='w-full p-8 hidden md:block'
						src='https://static.igem.wiki/teams/5066/home/big-picture-new.webp'
						alt='bigPicture'
					/>
				</div>
				<div data-aos='zoom-in'>
					<div className='relative w-full'>
						<img
							src={HomePaper}
							alt='homePaper'
							className='w-full h-auto'
						/>
						<div className='absolute inset-0 text-center top-1/3 right-1/5'>
							<h1 className='text-3xl md:text-5xl lg:text-7xl font-[DengueBeeters] italic'>
								<span class='text-[#E49898]'>Dengue </span>
								<span class='text-[#C94C67]'>Mos-quit-o </span>
								<br />
								<span class='text-[#E49898]'>in 2030!</span>
							</h1>
						</div>
					</div>
				</div>
			</div>

			{/* link section */}
			<div className='bg-gradient-to-b from-amber-50 to-[#e3f1fe]'>
				<div data-aos='fade-up'>
					<img
						className='pt-8 pb-4 lg:pt-16 mx-auto w-1/6'
						src='https://static.igem.wiki/teams/5066/new/cutemos.png'
						alt='cuteMosquito'
					/>
				</div>

				<p
					style={{ fontFamily: 'MyCustomFont, sans-serif' }}
					className='text-2xl md:text-4xl lg:text-7xl text-center font-bold text-[#C94C67]'
				>
					Explore me like one of your projects
				</p>

				<div className='grid grid-cols-6 md:grid-cols-5 mt-4 lg:mt-8 py-12 lg:py-24 gap-y-8'>
					<div className='col-span-2 md:col-span-1'>
						{/* Explore Project Button */}
						<div onClick={scrollToTop}>
							<Link to='/description'>
								<div className='flex flex-col items-center'>
									<img
										src={ExploreButton}
										alt='Explore Our Project Button'
										className='w-1/2 hover:scale-105 transition-transform duration-300'
									/>
									<p className='text-lg md:text-xl lg:text-2xl text-center mt-2 text-[#C94C67]'>
										Project
									</p>
								</div>
							</Link>
						</div>
					</div>

					<div className='col-span-2 md:col-span-1'>
						{/* Wet Lab Button */}
						<div onClick={scrollToTop}>
							<Link to='/engineering'>
								<div className='flex flex-col items-center'>
									<img
										src={WetlabButton}
										alt='Wet Lab Button'
										className='w-1/2 hover:scale-105 transition-transform duration-300'
									/>
									<p className='text-lg md:text-xl lg:text-2xl text-center mt-2 text-[#C94C67]'>
										Wet Lab
									</p>
								</div>
							</Link>
						</div>
					</div>

					<div className='col-span-2 md:col-span-1'>
						{/* Hardware Button */}
						<div onClick={scrollToTop}>
							<Link to='/hardware'>
								<div className='flex flex-col items-center'>
									<img
										src={HardwareButton}
										alt='Hardware Button'
										className='w-1/2 hover:scale-105 transition-transform duration-300'
									/>
									<p className='text-lg md:text-xl lg:text-2xl text-center mt-2 text-[#C94C67]'>
										Hardware
									</p>
								</div>
							</Link>
						</div>
					</div>

					<div className='col-start-2 col-span-2 md:col-span-1'>
						{/* Human Practices Button */}
						<div onClick={scrollToTop}>
							<Link to='/human-practices'>
								<div className='flex flex-col items-center'>
									<img
										src={HPButton}
										alt='Human Practices Button'
										className='w-1/2 hover:scale-105 transition-transform duration-300'
									/>
									<p className='text-lg md:text-xl lg:text-2xl text-center mt-2 text-[#C94C67]'>
										Human Practices
									</p>
								</div>
							</Link>
						</div>
					</div>

					<div className='col-start-4 col-span-2 md:col-span-1'>
						{/* Model Button */}
						<div onClick={scrollToTop}>
							<Link to='/Model'>
								<div className='flex flex-col items-center'>
									<img
										src={ModelButton}
										alt='Model Button'
										className='w-1/2 hover:scale-105 transition-transform duration-300'
									/>
									<p className='text-lg md:text-xl lg:text-2xl text-center mt-2 text-[#C94C67]'>
										Model
									</p>
								</div>
							</Link>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Home;
